/**
 * @license
 * @copyright Copyright Motili Inc., 2025 All Rights Reserved
 */

import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ViewedJobs } from 'common/types';

interface ContractorAvailableJobsState {
    activeTab: number;
    viewedJobs: ViewedJobs;
    searchText: string;
}

const initialState: ContractorAvailableJobsState = {
    activeTab: 0,
    searchText: '',
    viewedJobs: {},
};

const ContractorAvailableJobsSlice = createSlice({
    name: 'contractorAvailableJobs',
    initialState,
    reducers: {
        resetRecentlyViewedJobsStore() {
            return initialState;
        },
        addViewedJob(state, action: PayloadAction<ViewedJobs>) {
            state.viewedJobs = { ...state.viewedJobs, ...action.payload };
        },
        setActiveTab(state, action: PayloadAction<number>) {
            state.activeTab = action.payload;
        },
        setSearchText(state, action: PayloadAction<string>) {
            state.searchText = action.payload;
        },
    },
});

export const {
    addViewedJob,
    resetRecentlyViewedJobsStore,
    setActiveTab,
    setSearchText,
} = ContractorAvailableJobsSlice.actions;

export default ContractorAvailableJobsSlice.reducer;
